import $ from 'expose-loader?exposes=$,jQuery!jquery'
import intlTelInput from 'intl-tel-input'
import { xssFormat } from './utils'
import { notice } from '@pnotify/core'
import {
  OverlayScrollbars,
  ScrollbarsHidingPlugin,
  SizeObserverPlugin,
  ClickScrollPlugin
} from 'overlayscrollbars'

OverlayScrollbars.plugin([
  ScrollbarsHidingPlugin,
  SizeObserverPlugin,
  ClickScrollPlugin
])

export function drag(exports) {
  const _window = window,
    _document = document

  const mousemove = 'mousemove',
    mouseup = 'mouseup',
    mousedown = 'mousedown',
    EventListener = 'EventListener',
    addEventListener = 'add' + EventListener,
    removeEventListener = 'remove' + EventListener

  let newScrollX, newScrollY
  let dragged = []

  const reset = function (i, el) {
    for (i = 0; i < dragged.length;) {
      el = dragged[i++]
      el = el.container || el
      el[removeEventListener](mousedown, el.md, 0)
      _window[removeEventListener](mouseup, el.mu, 0)
      _window[removeEventListener](mousemove, el.mm, 0)
    }

    dragged = [].slice.call(_document.getElementsByClassName('nav-tabs'))

    for (i = 0; i < dragged.length;) {
      (function (el, lastClientX, lastClientY, pushed, scroller, cont) {
        (cont = el.container || el)[addEventListener](
          mousedown,
          cont.md = function (e) {
            if (
              !el.hasAttribute('nochilddrag')
              || _document.elementFromPoint(e.pageX, e.pageY) === cont
            ) {
              pushed = 1
              lastClientX = e.clientX
              lastClientY = e.clientY
              e.preventDefault()
            }
          },
          0
        )

        _window[addEventListener](
          mouseup,
          cont.mu = () => {pushed = 0},
          0
        )
        _window[addEventListener](
          mousemove,
          cont.mm = e => {
            if (pushed) {
              (scroller = el.scroller || el).scrollLeft -=
                newScrollX =
                (-lastClientX + (lastClientX = e.clientX))
              scroller.scrollTop -=
                newScrollY =
                (-lastClientY + (lastClientY = e.clientY))
              if (el === _document.body) {
                (scroller = _document.documentElement).scrollLeft -= newScrollX
                scroller.scrollTop -= newScrollY
              }
            }
          },
          0
        )
      })(dragged[i++])
    }
  }

  if (_document.readyState === 'complete') {
    reset()
  } else {
    _window[addEventListener]('load', reset, 0)
  }

  exports.reset = reset
}

export function mountPageScrollbars() {
  const sidebar = $('.sidebar-wrap'),
    dropdown = $('.dropdown-order-items'),
    domainTld = $('.domain-tld')

  if (sidebar.length > 0) {
    OverlayScrollbars(sidebar)
  }

  if ($('.nav-tabs-wrapper .nav-tabs').length > 0) {
    OverlayScrollbars($('.nav-tabs'))
  }

  if (dropdown.length > 0) {
    OverlayScrollbars(dropdown)
  }

  if (domainTld.length > 0) {
    OverlayScrollbars(domainTld)
  }
}

export function addScrollBars(set) {
  $.each(set, function () {
    const that = $(this)
    let scroll = that.data('scrollbar')
    if (scroll !== null) {
      scroll.update()
      return true
    }
    that.children()
      .wrapAll('<div class="scrollable"></div>')
      .end()
      .each(function (index) {
        const scroll = OverlayScrollbars(this, {})
        $(this).data('scrollbar', scroll)
      })
  })
}

export function initNavtabsSlider(el) {
  $(el).find('.slider')
    .css({width: parseInt(el.scrollWidth)})
  const m = $(el).find('li.active a')
  if (m.length) {
    let css = {width: $(m).width()}
    if ($('body').hasClass('rtl')) {
      css.right = ($(window).width() - ($(m).offset().left + $(m).outerWidth())) -
        ($(window).width() - ($(el).offset().left + $(el).outerWidth())) -
        $(el).scrollLeft()
    } else {
      css.left = $(m).offset().left - $(el).offset().left + $(el).scrollLeft() +
        parseInt($(m).css('marginLeft')) + parseInt($(m).css('paddingLeft'))
    }
    $(el).find('.slider .indicator').css(css)
  }
}

export function initNavtabsScroll(el) {
  let width = 0
  $(el).find('.nav-item').each(function () {
    width += parseInt($(this).outerWidth())
  })

  const arrowLeft = $(el).closest('.nav-tabs-wrapper').find('.nav-tabs-arrow-left')
  const arrowRight = $(el).closest('.nav-tabs-wrapper').find('.nav-tabs-arrow-right')

  const scr_l = Math.abs(el.scrollLeft)
  const scr_w = Math.abs(el.scrollWidth)
  const scr_r = Math.abs(scr_w - scr_l - parseInt($(el).width()))

  if (scr_l > 0 && scr_r > 0) {
    $(arrowLeft).show()
    $(arrowRight).show()
  } else if (scr_l > 0 && scr_r === 0) {
    if ($('body').hasClass('rtl')) {
      $(arrowLeft).hide()
      $(arrowRight).show()
    } else {
      $(arrowLeft).show()
      $(arrowRight).hide()
    }
  } else if (scr_l === 0 && scr_r > 0) {
    if ($('body').hasClass('rtl')) {
      $(arrowLeft).show()
      $(arrowRight).hide()
    } else {
      $(arrowLeft).hide()
      $(arrowRight).show()
    }
  } else if (parseInt(width) > parseInt($(el).closest('.nav-tabs-wrapper').width())) {
    $(arrowRight).show()
  } else {
    $(arrowLeft).hide()
    $(arrowRight).hide()
  }
}

export function processScroll() {
  const floater = $('#floater')
  let t = $(window).scrollTop() - $('#sidemenu').offset().top
  const maxi = $('#cart').height() - floater.height() - 15
  if (t > maxi)
    t = maxi
  if (t < 0)
    t = 0
  if ($('#mainmenu').hasClass('nav-fixed'))
    t += 60

  floater.animate(
    {top: t + 'px'},
    {queue: false, duration: 300}
  )
}

export function initNavtabs() {
  $('.nav-tabs-wrapper .nav-tabs').each(function (i) {
    const el = $(this),
      arrleft = `<span class="nav-tabs-arrow-left" style="display: none;"><i class="fa-solid fa-chevron-left fa-lg"></i></span>\n`,
      arrrght = `<span class="nav-tabs-arrow-right" style="display: none;"><i class="fa-solid fa-chevron-right fa-lg"></i></span>\n`

    if (window.location.hash && $(el).hasClass('init-by-hash')) {
      $(el).find('a').parent().removeClass('active')
      $(el).find('a[href="' + window.location.hash + '"]').parent()
        .addClass('active')
      $(el).find('a[href="' + window.location.hash + '"]').tab('show')
    }
    $(el).closest('.nav-tabs-wrapper').prepend(arrleft)
    $(el).closest('.nav-tabs-wrapper').append(arrrght)
    if ($(el).hasClass('nav-slider')) {
      $(el).prepend('<div class="slider"><div class="indicator"></div></div>')
    } else {
      $(el).find('.nav-slider').prepend('<div class="slider"><div class="indicator"></div></div>')
    }
    initNavtabsScroll($(this))
    initNavtabsSlider($(this))
    if (
      $(el).closest('.nav-tabs-wrapper').find('.nav-tabs-arrow-left').length > 0 &&
      $(el).closest('.nav-tabs-wrapper').find('.nav-tabs-arrow-right').length > 0
    ) {
      const arrowLeft = $(el).closest('.nav-tabs-wrapper').find('.nav-tabs-arrow-left')
      const arrowRight = $(el).closest('.nav-tabs-wrapper').find('.nav-tabs-arrow-right')
      const sclpx = 300 //scroll pixels
      const sclan = 100 //scroll animation, ms
      $(arrowLeft).on('click', () => {
        const scl = parseInt($(el).scrollLeft())
        $(el).animate({
          scrollLeft: scl - sclpx
        }, sclan)
      })

      $(arrowRight).on('click', () => {
        const scl = parseInt($(el).scrollLeft())
        $(el).animate({
          scrollLeft: scl + sclpx
        }, sclan)
      })
    }
    $(el).on('click', 'a.nav-link', function () {
      const m = $(this)
      const el = $(m).closest('.nav-tabs')
      $(el).find('li').removeClass('active')
      $(m).parent('li').addClass('active')
      if ($(el).hasClass('init-by-hash')) {
        window.location.hash = $(m).attr("href").substr(1)
      }
      initNavtabsSlider($(el).get(0))
    }).on('scroll', () => {
      initNavtabsSlider($(el).get(0))
      initNavtabsScroll($(el).get(0))
    })
  })
}

export function tableSplitToPages(target, filter) {
  filter = filter || 'tbody tr'
  const vclass = $('table', target).attr('class')
  let table = null

  $('table', target).hide()
    .removeClass('ui-slide')
    .addClass('ui-slide-disabled')
    .find(filter).each(function (i) {
    if (i % 3 === 0) {
      table = $('<table class="' + vclass + '"></table>').addClass('ui-slide')
        .insertAfter($('table:last', target))
      if (i > 0) {
        table.hide()
      }
    }
    $(this).show().detach().appendTo(table)
  })
  $('table', target).each(function () {
    const that = $(this)
    if (that.find('th').length) that.show()
    if (!that.find('tr').length) that.remove()
  })
}

export function initPhoneNumberField(el) {
  let opts = {
    separateDialCode: true,
    preferredCountries: [],
    formatOnDisplay: true,
    autoFormat: false
  }
  if ($(el).data('initial-country')) {
    opts.initialCountry = $(el).data('initial-country').toLowerCase()
  }
  const input = intlTelInput(el, opts)
  $(el).closest('form').on('submit', () =>  {
    const val = $(el).val()
    if (val !== '') {
      $(el).val(input.getNumber(window.intlTelInputUtils.numberFormat.INTERNATIONAL))
    }
  })
}

export function initCCard() {
  $('.card-number_js').on('keyup change', function () {
    const type = $(this).closest('.checkout').find('.card-type_js').val()
    let card_number = $(this).val().replace(/[^0-9]+/g, '').substring(0,16);
    $(this).val(card_number)

    if ($.isNumeric(card_number)) {
      if (type && type === 'American Express') {
        card_number = cardChunkAmex(card_number).join(' ');
      } else {
        card_number = cardChunk(card_number).join(' ');
      }
    }
    $(this).closest('.checkout').find('.credit-card-box-number').html(card_number);
  });

  $('.card-type_js').on('change', function () {
    const logo = $(this).closest('.checkout').find('.credit-card-box-logo');
    $(logo).attr('class', 'credit-card-box-logo');
    const val = xssFormat($(this).val());
    const type = getCreditCardTypeClass(val);
    if (type !== 'unknown') {
      $(logo).addClass(type);
    }
    $(this).closest('.checkout').find('.card-number_js').trigger('change')
  })

  $('.card-holder_js').on('keyup change', function () {
    $(this).closest('.checkout')
      .find('.credit-card-box-holder div')
      .html(xssFormat($(this).val()))
  })

  $('.card-expiration-month_js, .card-expiration-year_js').on('change', function () {
    const m = $(this).closest('.checkout').find('.card-expiration-month_js').val()
    const y = $(this).closest('.checkout').find('.card-expiration-year_js').val()
    if (y && m && $.isNumeric(m) && $.isNumeric(y)) {
      $(this).closest('.checkout')
        .find('.credit-card-box-expiration-date div')
        .html(m + '/' + y)
    } else {
      $(this).closest('.checkout')
        .find('.credit-card-box-expiration-date div')
        .html('')
    }
  })

  $('.card-ccv_js')
    .on('focus', function () {
      $(this).closest('.checkout')
        .find('.credit-card-box')
        .addClass('hover')
    })
    .on('blur', function () {
      $(this).closest('.checkout')
        .find('.credit-card-box')
        .removeClass('hover')
    })
    .on('keyup change', function () {
      const number = $(this).val()
      if ($.isNumeric(number)) {
        $(this).closest('.checkout').find('.credit-card-box-ccv div').html(number)
      } else {
        $(this).closest('.checkout').find('.credit-card-box-ccv div').html(number)
        $(this).val('')
      }
    })
}

function getCreditCardType(ccnumber) {
  const cc = (ccnumber + '').replace(/\s/g, '').replace('-', '')
  let result = 'unknown'

  if ((/^(34|37)/).test(cc) && cc.length === 15) {
    return 'American Express' //AMEX begins with 34 or 37, and length is 15.
  } else if ((/^(51|52|53|54|55)/).test(cc) && cc.length === 16) {
    return 'MasterCard' //MasterCard beigins with 51-55, and length is 16.
  } else if ((/^(4)/).test(cc) && (cc.length === 13 || cc.length === 16)) {
    return 'Visa' //VISA begins with 4, and length is 13 or 16.
  } else if ((/^(300|301|302|303|304|305|36|38)/).test(cc) && cc.length === 14) {
    return 'Dinersclub' //Diners Club begins with 300-305 or 36 or 38, and length is 14.
  } else if ((/^(2014|2149)/).test(cc) && cc.length === 15) {
    return 'Enroute' //enRoute begins with 2014 or 2149, and length is 15.
  } else if ((/^(6011)/).test(cc) && cc.length === 16) {
    return 'Discover' //Discover begins with 6011, and length is 16.
  } else if ((/^(3)/).test(cc) && cc.length === 16) {
    return 'JCB'  //JCB begins with 3, and length is 16.
  } else if ((/^(2131|1800)/).test(cc) && cc.length === 15) {
    return 'JCB'  //JCB begins with 2131 or 1800, and length is 15.
  } else if ((/^(6304|6706|6771|6709)/).test(cc) && cc.length >= 16 && cc.length <= 19) {
    return 'Laser'
  } else if ((/^(5018|5020|5038|6304|6759|6761)/).test(cc) && cc.length >= 12 && cc.length <= 19) {
    return 'Maestro'
  } else if ((/^(6334|6767)/).test(cc) && cc.length >= 16 && cc.length <= 19 && cc.length !== 17) {
    return 'Solo'
  }

  return result
}

function getCreditCardTypeClass(cctype) {
  let result = "unknown"

  if (cctype === 'American Express' || cctype === 'AmericanExpress') {
    return 'amex'
  } else if (
    cctype === 'MasterCard'
    || cctype === 'Master Card'
    || cctype === 'Master'
  ) {
    return 'master'
  } else if (cctype === 'Visa') {
    return 'visa'
  } else if (
    cctype === 'Dinersclub'
    || cctype === 'Diners'
    || cctype === 'Diners Club'
  ) {
    return 'dinersclub'
  } else if (cctype === 'Discover') {
    return 'discover'
  } else if (cctype === 'JCB') {
    return 'jcb'
  } else if (cctype === 'Laser') {
    return 'laser'
  } else if (cctype === 'Maestro') {
    return 'maestro'
  }

  return result
}

function cardChunk(str) {
  let ret = []
  const len = str.length
  for (let i = 0; i < len; i += 4) {
    ret.push(str.substring(i, i + 4))
  }
  return ret
}

function cardChunkAmex(str) {
  let ret = []
  ret.push(str.substring(0, 4))
  ret.push(str.substring(4, 10))
  ret.push(str.substring(10, 16))
  return ret
}

export function showDropzone(e) {
  const dropZone = $('#dropzone').not('.hidden')
  dropZone.show()
  setTimeout(()=> hideDropzone(), 6000)
}

export function hideDropzone() {
  $('#dropzone').hide().addClass('hidden')
}

export function paginationLi(page) {
  if (typeof page === 'undefined' || page === -1) {
    page = 1
  }

  let that = $(this),
    max = parseInt(that.attr('rel')) + 1,
    pages = [1],
    html = [];
  that.find('.page-li').remove()

  let htl = pages.length;
  for (let i = 1; i < max; i++) {
    const act = i === page ? 'active ' : '';
    html.push(`<li class="${act}page-li page-item"><a class="page-link" href="#${i}" onclick="return false;">${i}</a></li>`)
  }
  that.children().unbind('click')
    .on('click', function () {
      let that = $(this),
        currentPage = $('#currentpage'),
        page = parseInt(currentPage.val()),
        max = parseInt(that.parent('ul').attr('rel'))

      if (that.is('.page-item-left') && page > 0) {
        currentPage.val(page - 1).change()
      }
      else if (that.is('.page-item-right') && page + 1 < max) {
        currentPage.val(page + 1).change()
      }

      return false
    })
    .eq(0).after(html.join('')).end().end().find('.page-li a')
    .each(function () {
      if (!$(this).parent().is('.active')) {
        $(this).on('click', function () {
          if ($(this).attr('href')) {
            const p = parseInt($(this).attr('href').substr(1))
            paginationLi.call(that, p)
            $('#currentpage').val(p - 1).change()
          }
          return false
        })
      }
    })
}

export function sorterUpdate(low, high, total, pages) {
  $('ul[rel].pagination').each(function () {
    const self = $(this)
    self.attr('rel', pages)
    paginationLi.call(this, self.find('.active').index())
  })
}

export function notify(list, type) {
  for (let i in list) {
    notice({
      text: list[i],
      type: type,
      hide: false,
      sticker: false,
      icon: false
    })
  }
}

export function slidesCallback(e) {
  e.preventDefault()

  const that = $(this),
    wrapper = `<div class="ui-slide-wrapp"></div>`,
    target = that.attr('href') || 'body',
    speed = 400
  let t1, t2, direction

  if (that.is('.slide-left')) {
    t1 = $('.ui-slide:visible', target)
    t2 = t1.prev('.ui-slide')
    direction = 'left'
    if (!t2.length) {
      t2 = $('.ui-slide:last', target)
    }
  } else {
    t1 = $('.ui-slide:visible', target)
    t2 = t1.next('.ui-slide')
    direction = 'right'
    if (!t2.length) {
      t2 = $('.ui-slide:first', target)
    }
  }

  if (!t1.length || !t2.length || t1.is(t2)) {
    return false
  }

  const vp = t1.parent()
  vp.height(vp.height())
  vp.width(vp.width())

  t1.fadeOut(speed)
  t2 = t2.show().wrap(wrapper).parent()
  t2
    .css({
      top: t1.offset().top,
      width: t1.width(),
      minHeight: t1.height()
    })
    .show('slide', {direction: direction}, speed, () => t2.children().unwrap())

  return false
}

export function onSelectAllTld() {
  const self = $(this)
  if ($(self).hasClass('checked')) {
    $('.domain-tld-checkbox-item.checked').trigger('click')
    $(self).removeClass('checked')
  } else {
    $('.domain-tld-checkbox-item').not('.checked').trigger('click')
    $(self).addClass('checked')
  }
}

export function onLanguageChange(e) {
  e.preventDefault()

  $('.pageloader-item').show()
  $('.pageloader-wrapper').fadeIn('fast')

  $.get(this.getAttribute('href'))
    .always(() => window.location.reload())

  return false
}
